/**************************************************************************************************************************************************
*   MODULE NAME     :  EllipsisModal
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  13-01-2021
*   DESCRIPTION     :  Modal Component to Show Ellipsis Data
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import React from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
class EllipsisModal extends React.Component {

    state = {
        showEllipsisModal: this.props.showEllipsisModal,
        modalData: this.props.modalData,
        onHide: this.props.onHide,
        onOk: this.props.handleOkEllipsisModal,
        disableText: this.props.disableText
    }


    handleChange = (e) => {
        
        this.setState({
            ...this.state,
            modalData:{
                ...this.state.modalData,
                eleValue: e.target.value
            }
        })
    }

    render() {

        const {showEllipsisModal,modalData,onHide, onOk, disableText} = this.state;

        return (
            <Modal size='sm' show={showEllipsisModal} onHide={() => onHide()} centered  backdrop="static" autoFocus >
                <Modal.Header closeButton >
                    <Modal.Title>{modalData.eleLabel}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="">
                            <Form.Control as="textarea" rows="20"  onChange={this.handleChange} name={modalData.eleName} value={modalData.eleValue} disabled={disableText}/>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {!disableText && (<Button type="button" variant="primary" onClick={()=>onOk(modalData)}>OK</Button>)}
                    <Button type="button" variant="primary" onClick={() => onHide()} >Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default EllipsisModal;
